module.exports = __webpack_public_path__ + "img/Robot.81d1bce4.svg";